export default __webpack_public_path__ + "static/media/img2.213ede31.png";